import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import { Procedure } from './Main';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    procedure: Procedure | undefined;
    handleRunProcedure: () => Promise<void>;
    loading: boolean;
}

export default function ModalConfirm ({
    modal,
    setModal,
    procedure,
    handleRunProcedure,
    loading
}: Props) {

    const toggle = () => setModal(!modal);

    if (!procedure) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Confirm Run Procedure: {procedure.name}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <h6>This will {procedure.description}. Are you sure you want to proceed?</h6>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer update={true}>
                        <ActionIcon 
                            type='cancel'
                            onClick={toggle}
                        />
                        <ActionIcon 
                            type={'check'} 
                            loading={loading}
                            onClick={() => handleRunProcedure()}  
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;